export default __webpack_public_path__ + "static/media/enterprise_companies.065d75ca.svg";